
document.addEventListener("DOMContentLoaded", function () {
  const cardLinks = document.querySelectorAll('.cli-link, .new-cli-link');

  cardLinks.forEach(link => {
    link.addEventListener('click', function () {
      const targetLabel = this.getAttribute('cardlabel');

      if (!targetLabel) {
        console.warn("Missing cardlabel attribute");
        return;
      }

      const isNewClick = this.classList.contains('new-cli-link');

      // Remove active classes from everything except when clicking new-cli-link
      if (!isNewClick) {
        document.querySelectorAll('[cardlabel]').forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.new-collection-link-container').forEach(el => {
          el.classList.remove('active', 'show');
        });
      }

      // Add active to clicked item
      this.classList.add('active');

      // Find matching target elements
      const matchingElements = document.querySelectorAll(`div[cardlabel="${targetLabel}"]`);
      console.log(matchingElements);


      // Add active to all matches
      matchingElements.forEach(el => el.classList.add('active'));

      // Scroll to first visible match
      const firstMatch = Array.from(matchingElements).find(el => el.offsetParent !== null);
     if (firstMatch) {
          firstMatch.scrollIntoView({ behavior:"smooth", block:"start"})
        }

      // Initialize/reinitialize slider inside each matching element
      matchingElements.forEach(el => {
        const sliderWrapper = el.querySelector(".cust-slider-class");

        if (sliderWrapper) {
          const $slider = $(sliderWrapper);
          const liItems = $slider.find("li");
          const itemCount = liItems.length;
          const screenWidth = window.innerWidth;

          const shouldInitSlider =
            (screenWidth > 768 && itemCount > 3) || (screenWidth <= 768 && itemCount > 1);

          if (shouldInitSlider) {
            // Hide slider temporarily to avoid flicker
            sliderWrapper.style.visibility = 'hidden';

            setTimeout(() => {
              if ($slider.hasClass("slick-initialized")) {
                $slider.slick("unslick");
              }

              $slider.slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                centerMode: false,
                prevArrow: [
                  '<button type="button" class="slick-prev" aria-label="">',
                  '<span class="custom-arrow"><svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>',
                  '</button>',
                ].join(''),
                nextArrow: [
                  '<button type="button" class="slick-next" aria-label="">',
                  '<span class="custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="12.264" height="21.699" viewBox="0 0 12.264 21.699"><defs><style>.a{fill:none;stroke:#fff;stroke-width:2px;}</style></defs><path class="a" d="M-74,254.8l10.142,10.142L-74,275.084" transform="translate(74.707 -254.092)"/></svg></span>',
                  '</button>',
                ].join(''),
                responsive: [
                  { breakpoint: 900, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
                  { breakpoint: 549, settings: { slidesToShow: 2, slidesToScroll: 1, dots: true } },
                  { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } },
                ],
              });

              // Show the slider only after it’s fully initialized
              setTimeout(() => {
                sliderWrapper.style.visibility = 'visible';
              }, 50);
            }, 100);
          } else {
            console.info("Slider not initialized: insufficient <li> items.");
          }
        } else {
          console.warn("No slider found in element.");
        }
      });
    });
  });
});
